import { useRightPanel } from '@/core/right-panel/RightPanelContext'
import { useDiRef, useTransientDiRef } from '@/common/react/di-hooks'
import type { ObjectTypesService } from '@/object-types/services/ObjectTypesService'
import type { EditObjectController } from '../object-form/EditObjectController'
import { ObjectFormPage } from '../object-form/ObjectFormPage'
import type { ObjectModel } from '@/core/gql/gql-models-override'

interface Props {
  object: ObjectModel
}

export function EditObjectPanelPage({ object }: Props) {
  const { closePanel } = useRightPanel()
  const typesService = useDiRef<ObjectTypesService>('ObjectTypesService')

  const type = typesService.getTypeFromSelectedSpace(object.typeId)

  const controller = useTransientDiRef<EditObjectController>('EditObjectController', (c) => {
    if (type) c.init({ object, type, closePanel })
  })

  if (!type) return null

  return <ObjectFormPage controller={controller} />
}
